import { orchestrator } from 'satcheljs';
import {
    getShouldAutoScroll,
    isUpNextCalendarCacheId,
    getScenarioListCacheId,
} from '../selectors/agendaStoreSelectors';
import { onUpNextEventUpdated } from 'owa-upnext-event-loader';
import { loadFullEvent } from 'owa-calendar-events-loader';
import { scrollToUpNext } from '../actions/internalActions';
import { tryFetchAgendaViewMeetingInsights } from '../utils/tryFetchAgendaViewMeetingInsights';

export const onUpNextUpdatedOrchestrator = orchestrator(onUpNextEventUpdated, actionMessage => {
    const { eventsCacheLockId, id, parentFolderId } = actionMessage;
    const isStoredUpNextCalendarCacheId = isUpNextCalendarCacheId(eventsCacheLockId);
    if (isStoredUpNextCalendarCacheId.value) {
        const agendaScenarioId = isStoredUpNextCalendarCacheId.scenarioId;
        if (getShouldAutoScroll(agendaScenarioId)) {
            scrollToUpNext(agendaScenarioId);
        }
        // Load the full event into the eventsListCache
        if (id) {
            const eventListCacheId = getScenarioListCacheId(agendaScenarioId);
            loadFullEvent(eventListCacheId, id, parentFolderId);
        }
    }

    // Fetch meeting insights for up next event
    tryFetchAgendaViewMeetingInsights(id);
});
